import React, { Fragment} from 'react'
// 참고자료 (동영상)
const VOD =React.memo(function EquipInfoTab(VODProps){
    let vodSrc = VODProps?.NOTE
    let currentKey = VODProps?.key;
    vodSrc = vodSrc?.replaceAll("&gt;", ">");
    vodSrc = vodSrc?.replaceAll("&lt;", "<");
    vodSrc = vodSrc?.replaceAll('&quot;', '"');
    vodSrc = vodSrc?.replaceAll("&#39;", "'");

    return (
        <Fragment key ={currentKey}>
            <span dangerouslySetInnerHTML={{__html:vodSrc}} ></span>
            <a>{VODProps?.TITLE}</a>
        </Fragment>
    )
})
export default VOD;